import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  context.loading = false;
  context.abAccount.loading = false;
  if (response && response.data.response && response.data.response.filledAccountData && response.data.response.filledAccountData.userId) {
    context.airbnbToken = response.data.response.token;
    context.airbnbUserId = response.data.response.filledAccountData.userId;
    toastr.success(response.data.msg);
    context.next(5);
  } else if (response.data.msg) {
    toastr.success(response.data.msg);
    for(let account of context.airbnbAccounts) {
      if(account.username === response.data.response.username) {
        account.status = 1;
        context.$store.commit('AIRBNB_SHOULD_SYNC',0);
      }
    }
    context.next(6);
  }
};

// When the request fails
const failed = (error, context) => {
  context.$store.commit('AIRBNB_SHOULD_SYNC',1);

  if (error &&
    error.response &&
    error.response.data &&
    error.response.data.response &&
    error.response.data.response.client_error_info &&
    error.response.data.response.error_code) {

    if (error.response.data.response.error_code == 420) { // Action: "account_login"

      if (error.response.data.response.client_error_info.airlock && // Flow : "captcha_flow"
        error.response.data.response.client_error_info.airlock.flow === 'captcha_flow' &&
        !!(error.response.data.response.client_error_info.airlock.id)) {

        context.randomDeviceId = error.response.data.randomDeviceId;
        // context.next(2, error.response.data.response.client_error_info.airlock.id);
        context.activeStep = 99;
        context.next(99);

      } else if (error.response.data.response.client_error_info.airlock &&
        (error.response.data.response.client_error_info.airlock.flow === 'account_ownership_verification_for_login' ||
        error.response.data.response.client_error_info.airlock.flow === 'account_ownership_verification_forced_phone_only')) {
            
        context.randomDeviceId = error.response.data.randomDeviceId;
        context.next(3, error.response.data.response.client_error_info.airlock.id, error.response.data.response, error.response.data.response.client_error_info.airlock.friction_data);

      } else if (error.response.data.response.client_error_info.airlockV2) {

        context.airlockData.airlock = error.response.data.response.client_error_info.airlockV2.id;
        context.airbnbUserIsV2 = true;
        context.airlockId = error.response.data.response.client_error_info.airlockV2.id;
        context.randomDeviceId = error.response.data.randomDeviceId;
        if(error.response.data.response.client_error_info.airlockV2.viewPayload.frictionView === "ARKOSE_BOT_DETECTION") {
          context.activeStep = 99;
          context.next(99);
        }else{
          context.next(0, null, error.response.data.response);
        }

      } else if (error.response.data.response.error_message) {

        context.activeStep = 1;
        context.loading = false;
        toastr.error(error.response.data.response.error_message);

      }

    } else if (error.response.data.response.error_code == 403) {

      context.activeStep = 1;
      context.loading = false;
      toastr.error(context.$t('login.wrong_credentials'));

    } else if (error.response.data.response.error_message) {

      context.activeStep = 1;
      context.loading = false;
      toastr.error(error.response.data.response.error_message);

    }
  } else if (error && 
    error.response && 
    error.response.status == 400) {
      if(error.response.data.status === "error-google") {
        toastr.error(context.$t('login.airbnb_linked_google'));
      }else{
        if (error.response.data.msg &&
          error.response.data.msg == 'duplicated') {
          toastr.error(context.$t('account.settings.user_platforms_section.duplicated_airbnb_account'));
        }
        if (error.response.data.response && error.response.data.response.error_code && error.response.data.response.error_code == 403) {
          toastr.error(context.$t('login.wrong_credentials'));
        } else if(error.response.data.message){
          toastr.error(error.response.data.message);
        } else {
          toastr.error(context.$t('rentals.detail.modals.something_went_wrong'));
        }
      }
      if(error.response.data &&
        error.response.data.response &&
        error.response.data.response.error_message) {
        toastr.error(error.response.data.response.error_message);
      }
      context.activeStep = 1;
      context.loading = false;
  } else if (error && 
    error.response &&
    error.response.data &&
    error.response.data.code && 
    error.response.data.code === 535) {
      toastr.error("An unexpected error happened, please retry. (535)");
      context.activeStep = 1;
      context.loading = false;
  } else if (error && 
    error.response &&
    error.response.data &&
    error.response.data.response &&
    error.response.data.response.error_message) {
      toastr.error(error.response.data.response.error_message);
      context.activeStep = 1;
      context.loading = false;
    }

};

export default (context, account, user) => {

  const data = {
    account,
    randomDeviceId: context.randomDeviceId,
    email: user.email,
    user_id: user.id,
  };

  return Vue.$http.post('/add-airbnb-account', data).then((response) => {
    if (response && response.status === 200) {
      success(response, context);
    }
  }).catch((error) => {
    failed(error, context);
  });

};



// WEBPACK FOOTER //
// ./src/app/services/account/addAirbnbAccount.js